export default __webpack_public_path__ + "static/media/plain-sticker-Q.04b0aa4d.png";